import React from 'react';
import { Box, Typography } from '@mui/material';
import { fieldLabelSx, nativeInputSx } from '../common/formFieldStyles';
import { sanitizeDecimalInput } from '../../utils/stockQuantityUtils';

const PackageQuantityInput = ({
  id,
  label,
  value,
  onChange,
  error,
  helperText,
  min = 0,
  step = '0.001',
  maxDecimals,
  required = false,
}) => (
  <Box>
    <Typography variant="subtitle2" sx={fieldLabelSx}>
      {required ? `${label} *` : label}
    </Typography>
    <Box
      component="input"
      id={id}
      type="number"
      min={min}
      step={step}
      aria-label={label}
      value={value}
      onChange={(event) => onChange(
        maxDecimals == null ? event.target.value : sanitizeDecimalInput(event.target.value, maxDecimals),
      )}
      sx={nativeInputSx(Boolean(error))}
    />
    {error ? (
      <Typography variant="caption" sx={{ color: 'error.main', mt: 0.5, display: 'block' }}>
        {error}
      </Typography>
    ) : helperText ? (
      <Typography variant="body2" color="text.secondary" sx={{ mt: 0.75 }}>
        {helperText}
      </Typography>
    ) : null}
  </Box>
);

export default PackageQuantityInput;
